import { render, staticRenderFns } from "./downgrade_rules.vue?vue&type=template&id=6e40e653&scoped=true"
import script from "./downgrade_rules.vue?vue&type=script&lang=js"
export * from "./downgrade_rules.vue?vue&type=script&lang=js"
import style0 from "./downgrade_rules.vue?vue&type=style&index=0&id=6e40e653&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e40e653",
  null
  
)

export default component.exports